import SimpleWhiteBox from './SimpleWhiteBox';
import WeatherDailyTable from './WeatherDailyTable';

export default function WeatherDaily(props) {
  const weather = props.weather[0]
  const min = props.min
  return(
    <SimpleWhiteBox content={
        <>
          <WeatherDailyTable weather={weather} min={min} /> 
        </>
      }
    />
  )
}

